<div class="footer">
  <div class="float-right">
    <strong>HM SAS</strong>.
  </div>
  <div>
    <strong>Copyright</strong> HM Consulting &copy;
  </div>
</div>
